'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

require('flickity-as-nav-for');

var _flickity = require('flickity');

var _flickity2 = _interopRequireDefault(_flickity);

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CarouselNav = function CarouselNav(el) {
  (0, _classCallCheck3.default)(this, CarouselNav);

  new _flickity2.default((0, _functional.getElement)('.car-Slides_Items-carousel', { context: el }), {
    wrapAround: false,
    pageDots: false,
    initialIndex: 4,
    cellAlign: 'center',
    adaptiveHeight: true
  });

  new _flickity2.default((0, _functional.getElement)('.car-Slides_Items-carousel-nav', { context: el }), {
    asNavFor: (0, _functional.getElement)('.car-Slides_Items-carousel', { context: el }),
    cellAlign: 'center',
    contain: true,
    pageDots: false,
    wrapAround: false,
    draggable: false,
    prevNextButtons: false
  });
};

exports.default = CarouselNav;